<div fxLayout="row" fxFlex.lt-md="100%" >
  <div fxFlex="100">
    <mat-card>
      <div fxLayout="row">
        <h3>Dane umowy</h3>
      </div>

      <div fxLayout="row">
        <div fxFlex="100">
          <app-dict
            [label]="'Strona umowy'" [dictType]="'contract_owner'"
            [control]="ownerControl"
            [onlyKeys]=[CONTRACT_OWNER_PARTNER]
            [required]="true"
            [multiple]="false"
          ></app-dict>
        </div>
      </div>

<!--      <div fxLayout="row" *ngIf="requiredOfwca">-->
<!--        <div fxFlex="100">-->
<!--          <app-dict-ofwcas #dictOfwcas fxFlex="100" label="OFWCA" [control]="ofwcaControl" [required]="true"></app-dict-ofwcas>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" >
        <div fxFlex="100">
          <app-dict-partners #dictPartners fxFlex="100" label="Partner" [control]="partnerControl" [required]="true"></app-dict-partners>
        </div>
      </div>

      <div fxLayout="row" *ngIf="contracts.length > 0">
        <mat-form-field fxFlex="100">
          <mat-label>Umowa</mat-label>
          <mat-select [formControl]="control" [required]="true">
            <mat-option *ngFor="let contract of contracts" [value]="contract.uuid">
              {{ contract.type.name }} (nr: {{contract.number}}), zawarta {{contract.concludeDate | date:'y-MM-dd'}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
        </mat-form-field>
      </div>
    </mat-card>
  </div>
</div>
